"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _excluded = ["unique"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var propTypes = {
  unique: _propTypes.string
};

var Youtube = function Youtube(_ref) {
  var _ref$unique = _ref.unique,
      unique = _ref$unique === void 0 ? "" : _ref$unique,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("defs", {
    fill: "inherit"
  }), /*#__PURE__*/_react["default"].createElement("g", {
    fill: "inherit",
    fillRule: "evenodd",
    id: "glyphs/social/youtube-youtube" + unique,
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/_react["default"].createElement("use", {
    fill: "inherit",
    id: "combined-shape-youtube" + unique,
    xlinkHref: "#path-1-youtube" + unique
  }), /*#__PURE__*/_react["default"].createElement("g", {
    fill: "inherit",
    id: "colors/core/gunmetal-youtube" + unique
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M15.4363132,12.0241669 L9.81083237,9.10987235 L9.81083237,14.9369227 L15.4363132,12.0241669 Z M22.0004,12.0241669 C22.0004,19.1083336 22.0004,19.1083336 11.9988613,19.1083336 C2.0004,19.1083336 2.0004,19.1083336 2.0004,12.0241669 C2.0004,4.94000006 2.0004,4.94000006 11.9988613,4.94000006 C22.0004,4.94000006 22.0004,4.94000006 22.0004,12.0241669 Z",
    fill: "inherit",
    id: "path-1-youtube" + unique
  }))));
};

Youtube.propTypes = propTypes;
var _default = Youtube;
exports["default"] = _default;